<template>
    <v-text-field v-model="query" @input="onInput" v-bind="$attrs" v-on="$listeners">
        <!-- Loading spinner on the right side -->
        <template v-slot:append-outer>
            <v-progress-circular v-if="loading" indeterminate size="20" width="2" color="primary" />
        </template>
    </v-text-field>
</template>

<script>
import _ from "lodash";

export default {
    name: "DebouncedSearch",
    props: {
        debounceTime: {
            type: Number,
            default: 500
        },
        value: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            query: "",
            loading: false
        };
    },
    created() {
        // Wrap search trigger with debounce
        this.debouncedTrigger = _.debounce(this.triggerSearch, this.debounceTime);
    },
    mounted () {
        this.query = this.value || '';
    },
    methods: {
        onInput() {
            this.loading = true; // show spinner
            this.$emit('input', this.query)
            this.debouncedTrigger(this.query);
        },
        async triggerSearch(value) {
            try {
                // emit search event for parent to handle
                this.$emit("search", value, this.stopLoading);
            } catch (e) {
                this.stopLoading();
            }
        },
        stopLoading() {
            this.loading = false;
        }
    }
};
</script>
